import { Button, Card, Col, Row, Space, Tag, Typography } from "antd";
import {
  CustomerServiceOutlined,
  MailOutlined,
  MessageOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import { OLIVEEB_COLORS } from "workspaces/colors";

const { Paragraph, Text } = Typography;

const supportItems = [
  {
    title: "Product support",
    description: "Get help with projects, workspaces, subscriptions, or payment context.",
    icon: <CustomerServiceOutlined />,
    action: "Contact support",
  },
  {
    title: "Report an issue",
    description: "Share a reproducible issue so it can be reviewed with the right workspace context.",
    icon: <MessageOutlined />,
    action: "Prepare report",
  },
  {
    title: "Security help",
    description: "Ask for help with access, invitations, roles, privileges, or account security.",
    icon: <SafetyCertificateOutlined />,
    action: "Security request",
  },
];

const Support = () => (
  <div className="project-page">
    <div className="d-flex justify-content-between align-items-center mb-3 mt-3 gap-3 flex-wrap">
      <WidgetSectionTitle
        icon={<CustomerServiceOutlined />}
        title="Support"
        subtitle="Find the right path when you need help with Olreadia"
        className="flex-1"
        titleStyle={{ color: OLIVEEB_COLORS.oliveebDarkGreen }}
        subtitleStyle={{ color: OLIVEEB_COLORS.oliveebGreen }}
      />
    </div>

    <Row gutter={[16, 16]}>
      {supportItems.map((item) => (
        <Col xs={24} md={8} key={item.title}>
          <Card
            style={{
              height: "100%",
              borderRadius: 8,
              borderColor: OLIVEEB_COLORS.oliveebBlueSoft,
            }}
          >
            <Space direction="vertical" size={12} style={{ width: "100%" }}>
              <span
                style={{
                  display: "inline-grid",
                  placeItems: "center",
                  width: 42,
                  height: 42,
                  borderRadius: 8,
                  background: OLIVEEB_COLORS.oliveebBlueSoft,
                  color: OLIVEEB_COLORS.oliveebBlue,
                }}
              >
                {item.icon}
              </span>
              <div>
                <Text strong style={{ color: OLIVEEB_COLORS.oliveebDarkGreen }}>
                  {item.title}
                </Text>
                <Paragraph type="secondary" style={{ margin: "4px 0 0" }}>
                  {item.description}
                </Paragraph>
              </div>
              <Button icon={<MailOutlined />} style={{ width: "fit-content" }}>
                {item.action}
              </Button>
            </Space>
          </Card>
        </Col>
      ))}
    </Row>

    <Card
      style={{
        marginTop: 16,
        borderRadius: 8,
        borderColor: OLIVEEB_COLORS.goldBorder,
        background: OLIVEEB_COLORS.goldSoft,
      }}
    >
      <Space wrap>
        <Tag color="gold">Tip</Tag>
        <Text>
          Keep the workspace selected before contacting support so the URL includes the relevant context.
        </Text>
      </Space>
    </Card>
  </div>
);

export default Support;
